import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t-2 border-[#0A0A0A] bg-white mt-16" data-testid="site-footer">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-6">
                    <div>
                        <div className="text-[10px] font-black uppercase tracking-widest text-[#4A4A4A] mb-2">Explore</div>
                        <ul className="space-y-1.5 text-sm font-bold">
                            <li><Link to="/" className="hover:underline" data-testid="footer-home">Home</Link></li>
                            <li><Link to="/leaderboard" className="hover:underline">Top rated</Link></li>
                            <li><Link to="/discover" className="hover:underline">Discover</Link></li>
                            <li><Link to="/pricing" className="hover:underline">Pricing</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="text-[10px] font-black uppercase tracking-widest text-[#4A4A4A] mb-2">Community</div>
                        <ul className="space-y-1.5 text-sm font-bold">
                            <li><Link to="/guidelines" className="hover:underline" data-testid="footer-guidelines">Community Guidelines</Link></li>
                            <li><Link to="/dmca" className="hover:underline" data-testid="footer-dmca">DMCA / Copyright</Link></li>
                            <li><Link to="/appeal" className="hover:underline" data-testid="footer-appeal">Ban appeal</Link></li>
                            <li><a href="mailto:contact@feetrate.app" className="hover:underline">Contact / Report</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="text-[10px] font-black uppercase tracking-widest text-[#4A4A4A] mb-2">Legal</div>
                        <ul className="space-y-1.5 text-sm font-bold">
                            <li><Link to="/terms" className="hover:underline" data-testid="footer-terms">Terms of Service</Link></li>
                            <li><Link to="/privacy" className="hover:underline" data-testid="footer-privacy">Privacy Policy</Link></li>
                            <li><Link to="/disclaimer" className="hover:underline" data-testid="footer-disclaimer">Disclaimer</Link></li>
                            <li><Link to="/cookies" className="hover:underline" data-testid="footer-cookies">Cookie Policy</Link></li>
                            <li><Link to="/legal/changelog" className="hover:underline" data-testid="footer-changelog">Changelog</Link></li>
                            <li><Link to="/privacy#ccpa" className="hover:underline" data-testid="footer-ccpa">Do Not Sell My Info</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <div className="w-8 h-8 rounded-lg bg-[#FFE55C] border-2 border-[#0A0A0A] flex items-center justify-center font-black text-sm">
                                10
                            </div>
                            <span className="display font-black text-lg tracking-tight">footsie<span className="text-[#FF5A5F]">.</span></span>
                        </div>
                        <p className="text-xs text-[#4A4A4A] font-medium">
                            A tasteful place to rate feet. Strictly SFW. Adults 18+ only.
                        </p>
                    </div>
                </div>

                <div className="border-t-2 border-[#0A0A0A]/10 pt-4">
                    <div className="rounded-lg brut-inset bg-[#FFFDF7] p-3 mb-3 text-[11px] text-[#4A4A4A] font-medium leading-relaxed" data-testid="footer-disclaimer-block">
                        <strong className="text-[#0A0A0A]">Disclaimer:</strong> footsie is a user-generated content platform. All photos are uploaded by users who attest they are the sole rightful owners, are at least 18 years old, and that the content complies with our{" "}
                        <Link to="/guidelines" className="underline">Community Guidelines</Link> (strictly SFW). We do not verify identity or age at signup; report any violation and we&apos;ll take action. Nothing on this site is medical, legal, or professional advice.
                        {" "}Availability of features and content may vary by jurisdiction — residents of California (CCPA/CPRA), Virginia (VCDPA), Colorado (CPA), Connecticut (CTDPA), Utah (UCPA), Texas (TDPSA), Nevada (NRS 603A), the EEA / UK (GDPR), and Brazil (LGPD) have additional rights described in our{" "}
                        <Link to="/privacy" className="underline">Privacy Policy</Link>.
                    </div>
                    <div className="flex items-center justify-between flex-wrap gap-2 text-[11px] font-medium text-[#4A4A4A]">
                        <div>&copy; {new Date().getFullYear()} footsie. All rights reserved.</div>
                        <div>Payments processed by Stripe. Made with 💖 for tasteful raters.</div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
